/* DTC v2.1 patch */

function dtcAddDays(date, days, businessOnly) {
  const result = new Date(date.getTime());
  let added = 0;

  while (added < days) {
    result.setDate(result.getDate() + 1);
    if (!businessOnly || (result.getDay() !== 0 && result.getDay() !== 6)) {
      added += 1;
    }
  }

  return result;
}

function dtcFormatDate(date, format) {
  const shortMonth = date.toLocaleString('en-US', { month: 'short' });
  const longMonth = date.toLocaleString('en-US', { month: 'long' });
  const day = date.getDate();

  if (format === 'day_month') return `${day} ${shortMonth}`;
  if (format === 'long_month') return `${longMonth} ${day}`;
  return `${shortMonth} ${day}`;
}

function dtcFormatCountdown(ms) {
  if (ms < 0) ms = 0;
  const totalSeconds = Math.floor(ms / 1000);
  const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
  const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
  const seconds = String(totalSeconds % 60).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
}

function initDtcDeliveryPills() {
  document.querySelectorAll('[data-dtc-delivery-pill]:not([data-dtc-delivery-ready])').forEach((pill) => {
    pill.dataset.dtcDeliveryReady = 'true';

    const textTarget = pill.querySelector('[data-dtc-delivery-text]');
    if (!textTarget) return;

    const processingMin = parseInt(pill.dataset.processingMin || '0', 10);
    const processingMax = parseInt(pill.dataset.processingMax || '0', 10);
    const shippingMin = parseInt(pill.dataset.shippingMin || '0', 10);
    const shippingMax = parseInt(pill.dataset.shippingMax || '0', 10);
    const businessOnly = pill.dataset.businessDays === 'true';
    const dateFormat = pill.dataset.dateFormat || 'month_day';
    const prefix = pill.dataset.prefix || 'Order today to receive';
    const middle = pill.dataset.middle || 'between';
    const singleDateText = pill.dataset.singleDate || 'by';
    const cutoffHour = parseInt(pill.dataset.cutoffHour || '0', 10);
    const showCountdown = pill.dataset.showCountdown === 'true';
    const countdownText = pill.dataset.countdownText || 'Order within [time] to receive';

    function render() {
      const now = new Date();
      const cutoff = new Date(now.getTime());
      cutoff.setHours(cutoffHour, 0, 0, 0);

      let start = new Date(now.getTime());

      if (showCountdown && cutoffHour > 0 && now < cutoff) {
        const remaining = dtcFormatCountdown(cutoff.getTime() - now.getTime());
        textTarget.innerHTML = countdownText.replace('[time]', `<strong>${remaining}</strong>`);
      } else {
        textTarget.innerHTML = prefix;
      }

      if (cutoffHour > 0 && now >= cutoff) {
        start = dtcAddDays(start, 1, businessOnly);
      }

      const minDays = processingMin + shippingMin;
      const maxDays = processingMax + shippingMax;
      const minDate = dtcAddDays(start, minDays, businessOnly);
      const maxDate = dtcAddDays(start, maxDays, businessOnly);

      const minFormatted = dtcFormatDate(minDate, dateFormat);
      const maxFormatted = dtcFormatDate(maxDate, dateFormat);

      if (minFormatted === maxFormatted) {
        textTarget.innerHTML += ` ${singleDateText} <strong>${minFormatted}</strong>`;
      } else {
        textTarget.innerHTML += ` ${middle} <strong>${minFormatted} - ${maxFormatted}</strong>`;
      }
    }

    render();

    if (showCountdown && cutoffHour > 0) {
      setInterval(render, 1000);
    }
  });
}

document.addEventListener('DOMContentLoaded', initDtcDeliveryPills);
document.addEventListener('shopify:section:load', initDtcDeliveryPills);
